/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import './challengeModal.scss';

function ChallengeModal({ display, closeModal }) {
  const { logStages } = useSelector((state) => state.logReducer);
  const [actionUrl, setActionUrl] = useState('');
  const [setupFormInput, setSetupFormInput] = useState('');
  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    const payerAuthEnrollStage = logStages.find((stage) => {
      if (stage.stage === 5) return stage;
      return undefined;
    });
    if (payerAuthEnrollStage !== undefined && payerAuthEnrollStage.response.value !== null) {
      const { stepUpUrl, accessToken } =
        payerAuthEnrollStage.response.value.consumerAuthenticationInformation;
      setSetupFormInput(accessToken);
      setActionUrl(stepUpUrl);
      if (display && display === true) {
        const setupForm = document.getElementById('step_up_form');
        setupForm.submit();
      }
    }
  }, [display, logStages]);
  return (
    <>
      <form id="step_up_form" name="stepup" method="POST" action={actionUrl} target="stepUpIframe">
        <input id="step_up_form_jwt_input" type="hidden" name="JWT" value={setupFormInput} />
      </form>
      <button type="button" id="redirect_handler_button" onClick={handleClose}>
        Click
      </button>
      <Modal show={display}>
        <Modal.Header className="modal_closeButton" id="modal_closeButton">
          <Modal.Title>Please follow instructions from your bank</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            sandbox
            title="step up iframe"
            id="step_up_iframe"
            style={{ border: 'none', marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
            height="600px"
            width="400px"
            name="stepUpIframe"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ChallengeModal;
